import * as modalTypes from "../types/modalValuesTable";

const initialState = {
    active: false,
    coberturas: null,
    onloading: false,
    modal_PDF: {
        onloading: false,
        onerror: {
            error: false,
            message: null,
        },
        response: null
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case modalTypes.MODAL_VALUES_TABLE_ACTIVE:
            return {
                ...state,
                active: action.data,
            };
        case modalTypes.MODAL_VALUES_LOADING:
            return {
                ...state,
                onloading: action.data,
            };
        case modalTypes.MODAL_GET_COBERTURAS:
            return {
                ...state,
                coberturas: action.data,
            };
        case modalTypes.MODAL_DOWNLOAD_PDF_START:
            return {
                ...state,
                modal_PDF: {
                    ...state.modal_PDF,
                    response: null,
                    onloading: true
                }
            }
        case modalTypes.MODAL_DOWNLOAD_PDF_SUCCESS:
            return {
                ...state,
                modal_PDF: {
                    ...state.modal_PDF,
                    response: action.data,
                    onloading: false
                }
            }
        case modalTypes.MODAL_DOWNLOAD_PDF_FAIL:
            return {
                ...state,
                modal_PDF: {
                    ...state.modal_PDF,
                    onerror: action.error,
                }
            }
        case modalTypes.MODAL_CLEAR:
            return {
                ...state,
                modal_PDF: initialState.modal_PDF
            }
        default:
            return state;
    }
};
